<table *ngIf="!selectedRequirement" class="table">
  <thead>
  <tr>
    <th>{{ 'lang.requirementsList.requirement' | translate }}</th>
    <th>{{ 'lang.globals.filter' | translate }}</th>
    <th>{{ 'lang.globals.locationsScreens' | translate }}</th>
    <th>{{ 'lang.globals.created' | translate }}</th>
    <th class="text-end">{{ 'lang.globals.actions' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let requirement of requirements; index as i; last as last"
      [ngClass]="{'tw-opacity-50' : !requirement.active}">
    <td>
      <div class="d-flex align-items-center">
        <sb-action-required class="mr-4" [bookingStatus]="requirement.bookingStatus"></sb-action-required>
        <sb-comp-image-name-wrapper [medium]="requirement?.previewMedia">
          <span firstLine>{{ requirement?.name }}</span>
          <span secondLine *ngIf="requirement?.mediumGroups?.length > 0">
            {{ requirement?.mediumGroups.length }} {{ requirement?.mediumGroups?.length === 1 ? ('lang.globals.mediumGroup' |translate) : ('lang.globals.mediumGroups' |translate) }}
          </span>
        </sb-comp-image-name-wrapper>
      </div>
    </td>
    <td>
      <sb-comp-filter-overview
        [timeCull]="requirement?.timeCull" [geoCull]="requirement?.geoCull"
        [stateSpaceCull]="requirement?.stateSpaceCull" [playerCull]="requirement?.playerCull">
      </sb-comp-filter-overview>
    </td>
    <td>
      <div class="filter">
        <div class="filter__sum">
          <div class="filter__sum__item">
            <sb-icon icon="location"></sb-icon>
            {{ requirement?.playerAggregation?.locations | sbNumberFormat }}
          </div>
          /
          <div class="filter__sum__item">
            <sb-icon icon="screen"></sb-icon>
            {{ requirement?.playerAggregation?.screens | sbNumberFormat }}
          </div>
        </div>
      </div>
    </td>
    <td>
      <sb-comp-display-created [data]="requirement"></sb-comp-display-created>
    </td>
    <td class="text-end">
      <a (click)="selectedRequirement = requirement" ngbTooltip="{{'lang.globals.booking.edit' | translate}}"
         placement="left" container="body">
        <sb-button classes="btn-hover-primary mr-1">
          <sb-icon [icon]="'arrowRightAlt'"></sb-icon>
        </sb-button>
      </a>
    </td>
  </tr>
  </tbody>
</table>
<a *ngIf="selectedRequirement" (click)="selectedRequirement = null" class="mb-3">
  <sb-button classes="btn-default">
    <sb-icon class="mr-1" [icon]="'arrowLeftAlt'"></sb-icon>
    {{ 'lang.globals.back'|translate }}
  </sb-button>
</a>
<sb-comp-requirement-booking-assignment
  *ngIf="selectedRequirement" [readonlyCommercial]="true"
  [isInIntegratedContext]="true" [planningId]="bookingEditor.planningId"
  [requirementData]="selectedRequirement"
  [duration]="bookingEditor?.editingRecord?.get('commercial')?.duration"
>

</sb-comp-requirement-booking-assignment>

